import {
  UPDATE_FIELD_NAME,
} from '../constants';
import {
  makeSelectFieldData,
  makeSelectSalesForceData,
  selectGDPRSetting,
} from '../selectors';
import { updateFieldNameHandler } from '../asyncfields';

/**
 * Middleware to handle UPDATE_FIELD_NAME actions
 * Converts the saga-based field name update to a synchronous handler
 *
 * The middleware:
 * 1. Intercepts UPDATE_FIELD_NAME actions
 * 2. Collects required state via selectors
 * 3. Calls the synchronous updateFieldNameHandler
 * 4. Dispatches the returned actions in order
 */
export default function updateFieldNameMiddleware(storeAPI) {
  return (next) => (action) => {
    // Pass the action through first
    const result = next(action);

    // If it's a field name update action
    if (action.type === UPDATE_FIELD_NAME) {
      const state = storeAPI.getState();
      const { keyPath, incomingFieldName } = action;

      // Get the current field data from state
      const currentFieldDataSelector = makeSelectFieldData(keyPath);
      const currentFieldData = currentFieldDataSelector(state);

      // Get the previous name for conditionality update
      const previousFieldName = currentFieldData.name;

      // Get SF data for the new field name
      const sfDataSelector = makeSelectSalesForceData(incomingFieldName);
      const sfData = sfDataSelector(state);

      // Get GDPR setting
      const gdprSettingSelector = selectGDPRSetting();
      const gdprSetting = gdprSettingSelector(state);

      // Call the synchronous handler
      const actions = updateFieldNameHandler(
        action,
        currentFieldData,
        previousFieldName,
        sfData,
        gdprSetting,
      );

      // Dispatch all returned actions in order
      actions.forEach((a) => {
        storeAPI.dispatch(a);
      });
    }

    return result;
  };
}
